// Single source of truth for version to avoid require/import issues with package.json in ESM/TS
export const CLI_VERSION = '0.7.34';

export async function checkVersion() {
    // Placeholder for future update checks
}
